import {Component, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {Carteira} from "../../../carteira/carteira.model";
import {AssociacaoGrupoCarteiraVO} from "../../../grupo-carteira/associacao-grupo-carteira";

@Component({
  selector: 'app-modal-assoc-grupo-carteira',
  templateUrl: './modal-associacao-grupo-carteira.component.html',
  styleUrls: ['./modal-associacao-grupo-carteira.component.scss']
})
export class ModalAssociacaoGrupoCarteiraComponent implements OnInit {

  data: AssociacaoGrupoCarteiraVO;

  page$: Subject<number> = new Subject<number>();
  totalRegistros = 0;
  paginationTotalPage = 1;
  currentPage = 1;
  pageSize = 10;
  carteirasPaginadas: Carteira[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.data?.carteiras?.sort((a, b) => a.nome.localeCompare(b.nome));
    this.totalRegistros = this.data?.carteiras?.length;
    this.paginationTotalPage = Math.ceil(this.totalRegistros / this.pageSize);
    this.atualizarPaginacao();
  }

  updatePageSize($event: number): void {
    this.pageSize = $event;
    this.paginationTotalPage = Math.ceil(this.totalRegistros / this.pageSize);
    this.currentPage = 1;
    this.page$.next(1);
    this.atualizarPaginacao();
  }

  receiverPage(value: number) {
    this.currentPage = value;
    this.page$.next(value);
    this.atualizarPaginacao();
  }

  private atualizarPaginacao() {
    const inicio = (this.currentPage - 1) * this.pageSize;
    const fim = inicio + this.pageSize;
    this.carteirasPaginadas = this.data?.carteiras?.slice(inicio, fim);
  }
}
